import { determineFullTradeData } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { returnDealtFeeValueToRender } from "./DealtFeeCellRenderer";

// LQC-2351: at Affirmed the Unwind Amount value column swaps from "cash" to "dealtFee",
// so it needs the same raw-number copy behaviour LQC-2216 gave the cash column.
export function formatDealtFeeForCopy(params: any): string {
  if (!params.data) {
    return "";
  }

  const fullTradeData = determineFullTradeData(params);
  if (!fullTradeData) {
    return "";
  }

  const thisTrade =
    tradeDataStore
      .getState()
      .tradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  if (!thisTrade) {
    return "";
  }

  const value = returnDealtFeeValueToRender(params, thisTrade);
  if (value == null) {
    return "";
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return "";
  }

  // Sign is carried by the "Dealer Pays"/"Dealer Receives" text, matching the display.
  return Math.abs(numericValue).toFixed(2);
}

// AG Grid valueFormatter for the Unwind Amount value column at Affirmed.
export function dealtFeeCellValueFormatter(params: any): string {
  return formatDealtFeeForCopy(params);
}
